/**
 * Video service to handle video URL mapping from Vimeo IDs to local video files
 */

// Mapping of old Vimeo video IDs to local video files
const videoMapping = {
    // Hero animation video (originally vimeo.com/521339921) - now CloudFront hosted
    521339921: "https://d17jaka7b9kbh.cloudfront.net/homepage_hero_animation.mp4",

    // Homepage/Cupid background video (originally vimeo.com/293602484) - now CloudFront hosted
    293602484: "https://d17jaka7b9kbh.cloudfront.net/introduction_reelmetrics_-_short.mp4"
};

// WebM video mapping for better browser support and compression
const webmVideoMapping = {
    521339921: "/assets/videos/hero_animation.webm",
    293602484: "/assets/videos/introduction_reelmetrics.webm"
};

// Thumbnail mapping for video posters
const thumbnailMapping = {
    521339921: "/assets/images/hero-video-thumbnail.jpg", // Hero video thumbnail
    293602484: "/assets/images/intro-video-thumbnail.jpg" // Introduction video thumbnail (from user provided image)
};

/**
 * Get video URL for a given video ID
 * @param {string} videoId - The original Vimeo video ID
 * @returns {string} - Local video file URL
 */
export const getVideoUrl = videoId => {
    const videoUrl = videoMapping[videoId];
    if (!videoUrl) {
        return "";
    }
    return videoUrl;
};


/**
 * Get thumbnail URL for a given video ID
 * @param {string} videoId - The original Vimeo video ID
 * @returns {string} - Video thumbnail URL
 */
export const getThumbnailUrl = videoId => {
    return thumbnailMapping[videoId] || "";
};

/**
 * Get WebM video URL for a given video ID
 * @param {string} videoId - The original Vimeo video ID
 * @returns {string} - WebM video file URL
 */
export const getWebmVideoUrl = videoId => {
    const videoUrl = webmVideoMapping[videoId];
    if (!videoUrl) {
        return "";
    }
    return videoUrl;
};

/**
 * Get video sources array for HTML5 video element
 * @param {string} videoId - The original Vimeo video ID
 * @returns {Array} - Array of video source objects with src and type
 */
export const getVideoSources = videoId => {
    const sources = [];
    
    // Add WebM source first (better compression, supported by modern browsers)
    const webmUrl = getWebmVideoUrl(videoId);
    if (webmUrl) {
        sources.push({
            src: webmUrl,
            type: "video/webm"
        });
    }
    
    // Add MP4 source as fallback (wider browser support)
    const mp4Url = getVideoUrl(videoId);
    if (mp4Url) {
        sources.push({
            src: mp4Url,
            type: "video/mp4"
        });
    }
    
    return sources;
};

/**
 * Get video metadata for structured data
 * @param {string} videoId - The original Vimeo video ID
 * @returns {object} - Video metadata object
 */
export const getVideoMetadata = videoId => {
    const videoUrl = videoMapping[videoId];
    if (!videoUrl) {
        return {};
    }

    return {
        thumbnailUrl: getThumbnailUrl(videoId),
        contentUrl: `https://www.reelmetrics.com${videoUrl}`,
        embedUrl: `https://www.reelmetrics.com${videoUrl}`,
        uploadDate: "2020-01-01T08:00:00+08:00" // TODO: Update with actual dates
    };
};


export default {
    getVideoUrl,
    getThumbnailUrl,
    getWebmVideoUrl,
    getVideoSources,
    getVideoMetadata
};
